/**
 * Stacking modals is not supported by Boostrap by default
 * this little peace of code solves it
 */
export function useStackedModal() {
    $(document).on("hidden.bs.modal", ".modal", () => {
        if ($(".modal:visible").length) {
            $("body").addClass("modal-open");
        }
    });
}
